import { CONTACT_MAIL, LEGAL_URLS, PROVIDER } from './legal';

/**
 * Der Text neben dem Newsletter-Häkchen — an einer Stelle.
 *
 * **Warum eine eigene Datei mit Fassungsnummer.** Dieselbe Überlegung wie bei
 * [`rating-consent.ts`](../pages/song-rating/rating-consent.ts): wer sich auf
 * eine Einwilligung beruft, muss nachweisen können, worauf sie sich bezog. Der
 * Wortlaut wird mit der Einwilligung gespeichert, und zwei Kopien davon — eine
 * im Formular, eine im Nachweis — wären genau der Fehler, den man später nicht
 * mehr auflösen kann.
 *
 * **Warum das Häkchen leer startet und nichts freischaltet.** DSGVO Art. 7
 * Abs. 4: eine Leistung darf nicht von einer Einwilligung abhängen, die für
 * sie nicht nötig ist. Der Song ist auch ohne Newsletter freigeschaltet, und
 * ein vorangekreuztes Kästchen ist nach Art. 4 Nr. 11 ohnehin keine
 * Einwilligung.
 */

/** Bei jeder Änderung des Wortlauts hochzählen — auch bei einer sprachlichen. */
export const NEWSLETTER_CONSENT_VERSION = '2026-10-03b';

/** Rabatt für eine bestätigte Anmeldung. Muss zum Stripe-Coupon passen. */
export const NEWSLETTER_REWARD_PERCENT = 10;

/**
 * Kurzfassung am Häkchen — Zweck und Gegenwert, sonst nichts.
 *
 * **Warum der Widerruf nicht mehr danebensteht.** Er muss *vor* der
 * Einwilligung bekannt sein (Art. 7 Abs. 3 Satz 3 DSGVO), aber nicht in der
 * Zeile selbst. Einen Klick entfernt genügt, und das ist dieselbe Lösung wie
 * bei der Einwilligung zur Aufnahme: drei Zeilen Rechtstext neben einem
 * freiwilligen Häkchen kosten mehr Anmeldungen, als sie an Klarheit bringen.
 * Nur in der Bestätigungsmail stehen zu lassen wäre dagegen zu spät — erklärt
 * wird vor dem Haken, nicht danach.
 *
 * **Darf der Rabatt hier stehen?** Ja. Verboten ist nach DSGVO Art. 7 Abs. 4
 * die *Kopplung* — eine Leistung von einer Einwilligung abhängig zu machen,
 * die für sie nicht nötig ist. Ein Vorteil ist keine Bedingung: der Song ist
 * auch ohne Anmeldung zu haben, das Kästchen startet leer, und ein Widerruf
 * nimmt den Rabatt nicht nachträglich weg. Erst eins dieser drei umzudrehen
 * würde die Einwilligung unfrei machen.
 */
export const NEWSLETTER_CONSENT_TEXT =
  `Neuigkeiten und Angebote per E-Mail — als Dank ${NEWSLETTER_REWARD_PERCENT} % ` +
  'auf deinen nächsten Song.';

/** Die Langfassung hinter „Mehr". */
export const NEWSLETTER_DETAILS = {
  titel: 'Was du bekommst',
  absaetze: [
    'Ein paar Mal im Jahr eine E-Mail: neue Anlässe, Ideen für Geschenke und ' +
      `gelegentlich ein Angebot. Verantwortlich ist ${PROVIDER}.`,
    `Sobald du deine E-Mail bestätigt hast, liegt dein Code über ` +
      `${NEWSLETTER_REWARD_PERCENT} % in deinem Profil. Er gilt für deinen ` +
      'nächsten Song und ist einmal einlösbar.',
    'Du kannst jederzeit und ohne Angabe von Gründen widerrufen — ein ' +
      `formloser Hinweis an ${CONTACT_MAIL} genügt. Der Rabatt bleibt dir ` +
      'auch dann.',
  ],
  datenschutzUrl: LEGAL_URLS.datenschutz,
};
